/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanForm from 'vant/es/form'
import 'vant/es/form/style/less'


import { render, staticRenderFns } from "./Form.vue.js?vue&type=template&id=ea0dfe50!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Form.vue?vue&type=template&id=ea0dfe50"
import script from "./Form.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Form.vue?vue&type=script&lang=ts&setup=true"
export * from "./Form.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Form.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanForm})
